import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    document.addEventListener("DOMContentLoaded", function () {
        const fill = document.querySelector(".progress-fill");
        const autoplayTime = 5000; // 5 segundos

        const swiper = new Swiper(".banner__slider", {
            loop: false,
            autoplay: {
                delay: autoplayTime,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".banner-pagination",
                type: "fraction",
                clickable: false,
            },
            navigation: {
                nextEl: ".banner-button-next",
                prevEl: ".banner-button-prev",
            },
            on: {
                init: () => startProgress(),
                slideChangeTransitionStart: () => resetProgress(),
                slideChangeTransitionEnd: () => startProgress(),
            },
        });

        function startProgress() {
            fill.style.transition = `width ${autoplayTime}ms linear`;
            fill.style.width = "100%";
        }

        function resetProgress() {
            fill.style.transition = "none";
            fill.style.width = "0%";
        }
    });

    let timeLine = new Swiper(".line-content", {
        slidesPerView: 4,
        spaceBetween: 12,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 12,
            },
        },
        navigation: {
            nextEl: ".line-button-next",
            prevEl: ".line-button-prev",
        },
    });

    let enterpriseSlider = new Swiper(".enterprise__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".enterprise-pagination",
            type: "bullets",
            clickable: false,
        },
    });

    let galleryEnterprise = new Swiper(".gallery__slider", {
        watchOverflow: true,
        pagination: {
            el: ".gallery-pagination",
            type: "bullets",
            clickable: false,
        },
        navigation: {
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
        },
    });

    let detailsEnterprise = new Swiper(".details__slider", {
        watchOverflow: true,
        spaceBetween: 30,
        slidesPerView: 3,
        navigation: {
            nextEl: ".details-button-next",
            prevEl: ".details-button-prev",
        },
        breakpoints: {
            900: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 1,
            },
        },
    });
};
